import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import arrowLeftSm from './arrow-left-sm.svg';

function CircleShapedBackButton() {
  const history = useHistory();
  const handleClickButton = () => history.goBack();

  return (
    <StyledButton onClick={handleClickButton}>
      <img src={arrowLeftSm} alt='CircleShapedBackButton' />
    </StyledButton>
  );
}

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background-color: #f8f8f8;
  border: none;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: all 300ms;

  &:hover {
    filter: brightness(0.9);
  }

  &:active {
    filter: brightness(0.75);
  }
`;

export default CircleShapedBackButton;
